// @flow

import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Switch from '@material-ui/core/Switch';
import classNames from 'classnames';

import styles from './styles.module.scss';

type Props = {
  onChange: (e: Object) => void,
  value: boolean,
  disabled?: boolean,
  size?: 'default' | 'large',
};

export default function SwitchWithInsideText(props: Props) {
  const { onChange, disabled = false, size = 'default' } = props;
  const { formatMessage } = useIntl();

  const [value, setValue] = useState(props.value);

  const switchProps = {
    label: '',
    input: {
      name: 'switchWithText',
      value,
      onChange,
    },
    meta: {
      touched: false,
      error: '',
    },
    disabled,
  };

  useEffect(() => setValue(props.value), [props.value]);

  const isLarge = size === 'large';

  return (
    <Switch
      intl={{ formatMessage }}
      disableRipple
      checked={Boolean(value)}
      onChange={(e) => {
        const { checked } = e.target;
        setValue(checked);
        onChange(checked);
      }}
      classes={{
        root: classNames({ [styles.switchLarge]: isLarge, [styles.switch]: !isLarge }),
        thumb: classNames({ [styles.switchSwitchLarge]: isLarge, [styles.switchSwitch]: !isLarge }),
        track: classNames({ [styles.switchTrackLarge]: isLarge, [styles.switchTrack]: !isLarge }),
        switchBase: classNames({ [styles.switchBaseLarge]: isLarge, [styles.switchBase]: !isLarge }),
        checked: styles.checked,
      }}
      {...switchProps}
    />
  );
}
